import { ChannelProvider } from "ably/react";
import { useTranslation } from "react-i18next";
import { useAblyClient } from "../../../contexts/ably-provider";
import styles from "./ProviderChatContainer.module.css";
import { ProviderChatContent } from "./ProviderChatContent";

interface ProviderChatContainerProps {
	chatRoomId: string;
	participantName: string;
	currentUserId: string;
	currentUserName: string;
	userType: "patient" | "provider";
}

export function ProviderChatContainer(props: ProviderChatContainerProps) {
	const { client } = useAblyClient();
	const { t } = useTranslation("chatWithProvider");

	// Show loading state while Ably client initializes
	if (!client) {
		return (
			<div className={styles.loadingContainer}>
				<div className={styles.loadingText}>{t("loadingChat")}</div>
			</div>
		);
	}

	return (
		<ChannelProvider channelName={`chat:${props.chatRoomId}`}>
			<ProviderChatContent {...props} />
		</ChannelProvider>
	);
}
